import Data_protection_policy from './data_protection_policy';


export default Data_protection_policy;

export {
    Data_protection_policy
}